import { ReferentialKey } from 'api/referential';
import { ComponentKey } from 'enums/componentKey';
import { addressInputsConfig } from 'features/new-actor/form/inputs-config/addressInputsConfig';
import { personalInformationInputsConfig } from 'features/new-actor/form/inputs-config/personalInformationInputsConfig';
import { InputsConfig } from 'types/form/inputsConfig';
import {
  BorrowerInsuredFormFieldNames,
  BorrowerNaturalFormValues
} from '../borrowerInsuredForm';

export const borrowerNaturalInputsConfig: InputsConfig<
  Exclude<keyof BorrowerNaturalFormValues, 'id'>
> = {
  ...personalInformationInputsConfig,
  ...addressInputsConfig,

  [BorrowerInsuredFormFieldNames.SurveyForm]: {
    componentKey: ComponentKey.Custom,
    name: BorrowerInsuredFormFieldNames.SurveyForm
  },

  [BorrowerInsuredFormFieldNames.ProspectType]: {
    componentKey: ComponentKey.ReferentialDropdown,
    name: BorrowerInsuredFormFieldNames.ProspectType,
    referentialKey: ReferentialKey.ProspectType,
    required: true,
    label: 'BORROWER_INSURED_FORM.LABELS.PROSPECT_TYPE'
  },

  [BorrowerInsuredFormFieldNames.IsFPE]: {
    componentKey: ComponentKey.Checkbox,
    name: BorrowerInsuredFormFieldNames.IsFPE,
    required: true,
    label: 'BORROWER_INSURED_FORM.LABELS.IS_FPE'
  },

  [BorrowerInsuredFormFieldNames.Job]: {
    componentKey: ComponentKey.InputText,
    name: BorrowerInsuredFormFieldNames.Job,
    type: 'text',
    required: true,
    label: 'BORROWER_INSURED_FORM.LABELS.JOB',
    placeholder: 'BORROWER_INSURED_FORM.LABELS.JOB_PLACEHOLDER'
  },

  [BorrowerInsuredFormFieldNames.BorrowerId]: {
    componentKey: ComponentKey.Custom,
    name: BorrowerInsuredFormFieldNames.BorrowerId
  }
};
